class OiFaq {
    private oiFaqElement: HTMLElement | null
    private questionElement: HTMLElement | null
    private answerElement: HTMLElement | null

    constructor(oiFaqElement: HTMLElement) {
        console.log('OiFaq: Constructor')
        this.oiFaqElement = oiFaqElement
        this.questionElement = this.oiFaqElement.querySelector('.js-faq-question')
        this.answerElement = this.oiFaqElement.querySelector('.js-faq-answer')

        if (this.answerElement && this.questionElement) {
            this.questionElement.addEventListener('click', (e) => {
                e.preventDefault()
                console.log("Toggle faq")

                this.questionElement.classList.toggle('is-open')

                if (this.answerElement.classList.contains('is-open')) {
                    // closing
                    this.answerElement.style.maxHeight = '0px'
                    this.answerElement.style.opacity = '0'
                    this.answerElement.classList.remove('is-open')
                } else {
                    // opening
                    this.answerElement.style.maxHeight = this.answerElement.scrollHeight + 'px'
                    this.answerElement.style.opacity = '1'
                    this.answerElement.classList.add('is-open')
                }
            })
        }
    }
}

export default OiFaq
